import { getSTOMPClient } from '~/components/sportsbook/lobby/api/betting-service/stomp-client';

export const connectToSTOMP = () => getSTOMPClient().connect();
export const disconnectFromSTOMP = () => getSTOMPClient().disconnect();
export const updateBettingSessionExpiration = (bettingSessionExpiresOn: string | null) =>
	getSTOMPClient().updateBettingSessionExpiration(bettingSessionExpiresOn);
